import type { VFC } from 'react';
import { useSelector } from 'react-redux';
import IssuesSearch from './IssuesSearch';
import css from './IssuesInboxHeader.module.less';
import { exceptionsEnabledCategories } from '../../../../shared/issuesV2';
import { BUTTON_SIZE, NavigationButton } from '../../generic/Button';
import * as IssuesV2Store from '../../../redux/issuesV2';

/**
 * The header for the issues inbox, containing search and the link to the ignore rules.
 */
const IssuesInboxHeader: VFC = () => {
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const pathname = window.location.pathname;

  return (
    <div className={css.header}>
      <div className={css.search}>
        <IssuesSearch />
      </div>
      <div className={css.buttons}>
        {exceptionsEnabledCategories.includes(category) &&
        <NavigationButton to={`${pathname}/exceptions`} type="secondary" size={BUTTON_SIZE.MEDIUM}>View Ignore Rules</NavigationButton> }
      </div>
    </div>
  );
};

export default IssuesInboxHeader;
